var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1ModeEcoCold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 2A1.5 1.5 0 0167 3.48v5.37l4.67-2.76a1.5 1.5 0 111.53 2.58l-4.75 2.81 4.68 2.77a1.55 1.55 0 01.76 1.69 1.501 1.501 0 01-2.22.94L67 14.11v5.37a1.5 1.5 0 11-3 0v-5.37l-4.67 2.76a1.5 1.5 0 01-2.22-.94 1.55 1.55 0 01.76-1.69l4.68-2.77-4.69-2.77a1.54 1.54 0 01-.77-1.63 1.501 1.501 0 012.24-1L64 8.85V3.48A1.5 1.5 0 0165.5 2zM36.74 16.85c-.73.143-1.45.327-2.16.55-10.91 3.54-16.81 15.52-13.17 26.78 3.64 11.26 15.44 17.52 26.36 14a20.18 20.18 0 009.89-7.06 20.94 20.94 0 01-20.92-34.27z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F1_Mode_eco_cold.8c805b6c.svg";
export { SvgF1ModeEcoCold as ReactComponent };